import { defaultGetResponse } from "interfaces/ActionReducer/GetRequest/GetResponse";
import {
    GET_PROPOSED_LINKS,
    GET_PROPOSED_LINK_INFO,
    ProposedLinksState,
    ProposedLinkTypes,
    PROPOSED_LINKS_RECEIVED,
    SET_PROPOSED_LINKS_FILTERS,
    SET_PROPOSED_LINK_INFO,
    TOGGLE_PROPOSED_CHANGES,
    TOGGLE_PROPOSED_LAYER
} from "../../actions/regulation/proposedLinks/types";
import { RESET_STATE } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

const initialState: ProposedLinksState = {
    isProposedLinksReceived: false,
    isProposedChanges: false,
    proposedLinks: {},
    toggle: false,
    proposedLinksFilters: {
        sub_activity: "",
        date: new Date(),
        time: new Date()
    },
    proposedLinkInfo: defaultGetResponse.results,
    isAllProposedLinkInfoReceived: false
};

const proposedLinks = (state = initialState, action: ProposedLinkTypes): ProposedLinksState => {
    switch (action.type) {
        case GET_PROPOSED_LINKS: {
            return {
                ...state,
                isProposedLinksReceived: false
            };
        }
        case PROPOSED_LINKS_RECEIVED: {
            return {
                ...state,
                isProposedLinksReceived: true,
                proposedLinks: action.payload.proposedLinks
            };
        }
        case TOGGLE_PROPOSED_CHANGES: {
            return {
                ...state,
                toggle: action.payload.toggle
            };
        }
        case TOGGLE_PROPOSED_LAYER: {
            return {
                ...state,
                isProposedChanges: action.payload.isProposedChanges
            };
        }
        case SET_PROPOSED_LINKS_FILTERS: {
            return {
                ...state,
                proposedLinksFilters: action.payload.proposedLinksFilters
            };
        }
        case GET_PROPOSED_LINK_INFO: {
            return {
                ...state,
                isAllProposedLinkInfoReceived: false
            };
        }
        case SET_PROPOSED_LINK_INFO: {
            return {
                ...state,
                proposedLinkInfo: action.payload.proposedLinkInfo,
                isAllProposedLinkInfoReceived: true
            };
        }
        case RESET_STATE: {
            return {
                ...initialState
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
};

export default proposedLinks;
